module.exports = __webpack_public_path__ + "img/15_2.f38379c3.jpg";